import React from "react"
import "../../styles/Common/TextMultiStyle.less"
export default function TextMultiStyle(props) {
  return (
    <div onClick={props.onClick}>
      <h2 className={props.StyleText} dangerouslySetInnerHTML={{ __html: props.text }}></h2>
    </div>
  )
}
